import React, { useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './VideoSection.css';

const videoCards = [
  {
    id: 1,
    title: '10 Lines on Sree Narayana Guru in English | Few Lines....',
    channel: 'SNDP Yogam',
    duration: '12:30',
    thumbnail: 'Sivagiri_Ashramam_at_Varkkala-scaled.jpg',
  },
  {
    id: 2,
    title: '10 Lines on Sree Narayana Guru in English | Few Lines....',
    channel: 'SNDP Yogam',
    duration: '12:30',
    thumbnail: 'image-2.png',
  },
  {
    id: 3,
    title: '10 Lines on Sree Narayana Guru in English | Few Lines....',
    channel: 'SNDP Yogam',
    duration: '12:30',
    thumbnail: 'Sivagiri_Ashramam_at_Varkkala-scaled.jpg',
  },
  {
    id: 4,
    title: '10 Lines on Sree Narayana Guru in English | Few Lines....',
    channel: 'SNDP Yogam',
    duration: '12:30',
    thumbnail: 'image-2.png',
  },
];

const VideoSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <section className="video-section" id="videos">
      {/* Video Player Area */}
      <div className="video-player">
        <img
          src="/Sndp/567575675756-scaled.jpg"
          alt="Video"
          className="video-player-bg"
        />
        <div className="video-controls">
          <div className="video-progress-bar">
            <div className="progress-triangle"></div>
            <div className="progress-track">
              <div className="progress-fill"></div>
            </div>
            <span className="video-time">10:25</span>
          </div>
          <div className="video-control-icons">
            <button className="control-btn" aria-label="Volume">🔊</button>
            <button className="control-btn" aria-label="Fullscreen">⛶</button>
          </div>
        </div>
      </div>

      {/* Watch Next Section */}
      <div className="watch-next">
        <div className="watch-next-header">
          <h2 className="watch-next-title">Watch<br />Next</h2>
          <div className="watch-next-nav">
            <button
              className="watch-nav-btn prev"
              onClick={() => setCurrentSlide(Math.max(0, currentSlide - 1))}
            >
              <FiChevronLeft size={40} color="#444" />
            </button>
            <button
              className="watch-nav-btn next"
              onClick={() => setCurrentSlide(Math.min(videoCards.length - 1, currentSlide + 1))}
            >
              <FiChevronRight size={40} color="#444" />
            </button>
          </div>
        </div>

        <div className="video-cards-container">
          {videoCards.map((card) => (
            <div key={card.id} className="video-card">
              <div className="video-card-thumbnail">
                <img
                  src={`/Sndp/${card.thumbnail}`}
                  alt={card.title}
                />
                <span className="video-card-duration">{card.duration}</span>
              </div>
              <div className="video-card-info">
                <h4 className="video-card-title">{card.title}</h4>
                <span className="video-card-channel">{card.channel}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
